import React, { useEffect, useState } from "react";

import { Pagination, Row, Table } from "antd";

const orderTitleStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "3px",
  cursor: "pointer",
};
const orderTitleBoldStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "3px",
  cursor: "pointer",
  fontWeight: "bold",
};

const StatisticsTable = ({
  title = "상품별 상세내역",
  data,
  handleChangeOffset,
  tableLoading,
  setSortOrder,
}) => {
  /**
   * 정렬 순서 정리
   * @param type
   */
  const handleSortOrder = (type) => {
    let orderType = data.sortOrder?.orderType;
    let orderBy = data.sortOrder?.orderBy;
    if (type === orderType) {
      setSortOrder({
        ...data.sortOrder,
        orderBy: orderBy === "desc" ? "asc" : "desc",
      });
    } else {
      setSortOrder({
        orderType: type,
        orderBy: "desc",
      });
    }
  };

  const columns = [
    {
      title: "상품명",
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
      width: "25%",
      align: "center",
      render: (value, record) => {
        return `${record?.is_cooperate ? "[공동구매] " : ""}${value}`;
      },
    },
    {
      title: "옵션명",
      dataIndex: "option_name",
      key: "option_name",
      ellipsis: true,
      width: "20%",
      align: "center",
    },
    {
      title: (
        <span
          style={
            data.sortOrder.orderType === "total_sales_amount"
              ? orderTitleBoldStyle
              : orderTitleStyle
          }
          onClick={() => handleSortOrder("total_sales_amount")}
        >
          매출금액
          <img
            src={`/assets/images/notice-${
              data.sortOrder.orderType === "total_sales_amount" &&
              data.sortOrder.orderBy === "asc"
                ? "fold"
                : "expand"
            }.png`}
            alt={`에디터 접기펼치기 아이콘`}
            style={{
              width: "1em",
              height: "auto",
              cursor: "pointer",
            }}
          />
        </span>
      ),
      dataIndex: "total_sales_amount",
      key: "total_sales_amount",
      ellipsis: true,
      width: "25%",
      align: "center",
      render: (value) => {
        return (
          <span
            style={{
              color: "#117ffa",
              maxWidth: "30%",
              overflow: "hidden",
            }}
          >
            {value?.toLocaleString()}
          </span>
        );
      },
    },
    {
      title: (
        <span
          style={
            data.sortOrder.orderType === "total_purchases_num"
              ? orderTitleBoldStyle
              : orderTitleStyle
          }
          onClick={() => handleSortOrder("total_purchases_num")}
        >
          판매수량
          <img
            src={`/assets/images/notice-${
              data.sortOrder.orderType === "total_purchases_num" &&
              data.sortOrder.orderBy === "asc"
                ? "fold"
                : "expand"
            }.png`}
            alt={`에디터 접기펼치기 아이콘`}
            style={{
              width: "1em",
              height: "auto",
              cursor: "pointer",
            }}
          />
        </span>
      ),
      dataIndex: "total_purchases_num",
      key: "total_purchases_num",
      width: "15%",
      align: "center",
      render: (value) => {
        return (
          <span style={{ color: "#1ca717" }}>{value?.toLocaleString()}</span>
        );
      },
    },
    {
      title: (
        <span
          style={
            data.sortOrder.orderType === "unit_price_avg"
              ? orderTitleBoldStyle
              : orderTitleStyle
          }
          onClick={() => handleSortOrder("unit_price_avg")}
        >
          객단가
          <img
            src={`/assets/images/notice-${
              data.sortOrder.orderType === "total_sales_amount" &&
              data.sortOrder.orderBy === "asc"
                ? "fold"
                : "expand"
            }.png`}
            alt={`에디터 접기펼치기 아이콘`}
            style={{
              width: "1em",
              height: "auto",
              cursor: "pointer",
            }}
          />
        </span>
      ),
      dataIndex: "unit_price_avg",
      key: "unit_price_avg",
      width: "15%",
      align: "center",
      render: (value) => {
        return (
          <span style={{ color: "#bbc71d" }}>{value?.toLocaleString()}</span>
        );
      },
    },
  ];
  return (
    <>
      <Row
        className="product-register-border-box"
        justify={"space-between"}
        wrap={false}
        style={{ marginTop: 20, borderBottom: 0 }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <span className="product-register-box-title">{title}</span>
        </div>
      </Row>
      <div
        className="product-register-border-box statistic-graph"
        style={{ padding: "20px 25px 40px", height: "fit-content" }}
      >
        <Table
          className="order-create-product-list-table"
          // rowSelection={productRowSelection}
          columns={columns}
          dataSource={data.productList}
          loading={tableLoading}
          bordered
          size="middle"
          rowKey={(obj) =>
            `${obj.product_name}_${obj.option_name}_${obj.total_sales_amount}_${obj.total_purchases_num}`
          }
          rowClassName="coupon-table-row"
          scroll={{ x: "calc(500px + 50%)" }}
          // onRow={handleProductRowEvent}
          // onChange={tableOnChange}
          // tableLayout="auto"
          pagination={false}
        />
        <div style={{ textAlign: "right" }}>
          <Pagination
            // showQuickJumper
            // showSizeChanger
            // onShowSizeChange={pageSizeChange}
            pageSize={data.pageSize}
            total={data.totalSize}
            onChange={handleChangeOffset}
            style={{ marginTop: 20 }}
            current={data.currentPageNumber}
          />
        </div>
      </div>
    </>
  );
};

export default StatisticsTable;
